import { PropertyTypeInteractor, PropertyTypeRequest, PropertyTypeStructRequest } from "../../Coordinator/PropertyType/PropertyTypeInteractor";

export class PropertyTypeViewModel {
	private interactor: PropertyTypeInteractor;

	constructor() {
		this.interactor = new PropertyTypeInteractor();
	}

	public fetchSave(obj: any): PromiseLike<any> {
		var request = new PropertyTypeRequest(
			obj["sgeptipoimovel"] ? parseInt(obj["sgeptipoimovel"]) : 0,
			obj["nome"] ? obj["nome"] : "",
			obj["codigo"] ? obj["codigo"] : "",
		)
		return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res(true)
			}, e => {
				return rej(e)
			});
		})
	}

	public fetchDataOne(obj: any): PromiseLike<any> {
		var request = new PropertyTypeStructRequest(obj["sgeptipoimovel"] ? parseInt(obj["sgeptipoimovel"]) : 0)
		return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
}